import { useState } from "react";
import { Switch } from "../../components/ui/switch";
import { toast } from "sonner";
import { inr, PLAN_META } from "./mockData";

export function SetupTab({ flats }) {
  const [lateFee, setLateFee] = useState(false);
  const [discount, setDiscount] = useState(5);
  const [plans, setPlans] = useState(() => Object.fromEntries(flats.map((f) => [f.id, f.plan])));

  return (
    <div className="space-y-5">
      <div className="rounded-2xl border border-stone-200 bg-white p-4 space-y-4">
        <div className="text-sm font-semibold">Community rules</div>
        <div className="flex items-center justify-between gap-4">
          <div>
            <div className="text-sm">Maintenance rate</div>
            <div className="text-[11px] text-stone-500">Base rate per flat, per month</div>
          </div>
          <div className="flex items-center gap-1 text-sm font-semibold">
            ₹ <input defaultValue={2000} data-testid="rate-input" className="w-20 rounded-lg border border-stone-200 p-1.5 text-sm text-right" />
          </div>
        </div>
        <div className="flex items-center justify-between gap-4">
          <div>
            <div className="text-sm">Annual upfront discount</div>
            <div className="text-[11px] text-stone-500">For flats paying the full year in advance</div>
          </div>
          <div className="flex items-center gap-1 text-sm font-semibold">
            <input value={discount} onChange={(e) => setDiscount(e.target.value)} data-testid="discount-input"
              className="w-14 rounded-lg border border-stone-200 p-1.5 text-sm text-right" /> %
          </div>
        </div>
        <div className="flex items-center justify-between gap-4">
          <div>
            <div className="text-sm">Late fee</div>
            <div className="text-[11px] text-stone-500">Off by default. Even when on, it's never auto-charged — treasurer applies it per case to avoid disputes.</div>
          </div>
          <Switch checked={lateFee} onCheckedChange={(v) => { setLateFee(v); toast(v ? "Late fee enabled (manual, per-case only)" : "Late fee disabled"); }} data-testid="latefee-switch" />
        </div>
      </div>

      <div>
        <div className="text-sm font-semibold mb-1">Per-flat payment plans</div>
        <p className="text-[11px] text-stone-500 mb-2">Each flat picks its own cycle. Annual gets the {discount}% discount automatically. Old arrears entered once as opening balance.</p>
        <div className="rounded-2xl border border-stone-200 bg-white divide-y divide-stone-100 overflow-hidden">
          {flats.map((f) => (
            <div key={f.id} className="flex items-center gap-3 p-3" data-testid={`setup-row-${f.flat}`}>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium">{f.flat}</div>
                <div className="text-[11px] text-stone-500 truncate">{f.name}</div>
              </div>
              <select value={plans[f.id]} onChange={(e) => { setPlans({ ...plans, [f.id]: e.target.value }); toast(`${f.flat} → ${PLAN_META[e.target.value].label}`); }}
                data-testid={`plan-select-${f.flat}`}
                className="rounded-lg border border-stone-200 p-1.5 text-xs bg-white">
                {Object.entries(PLAN_META).map(([k, p]) => <option key={k} value={k}>{p.label}</option>)}
              </select>
              <div className="w-20 text-right">
                {f.arrears > 0
                  ? <span className="text-[11px] text-red-600 font-semibold">{inr(f.arrears)} <span className="text-stone-400 font-normal block text-[10px]">opening arrears</span></span>
                  : <span className="text-[11px] text-stone-300">—</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
